var map = {
	"./man-01.png": "./src/components/test/camera/media-pipe/face-detector/sample/man-01.png",
	"./woman-01.png": "./src/components/test/camera/media-pipe/face-detector/sample/woman-01.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/test/camera/media-pipe/face-detector/sample sync recursive ^\\.\\/.*$";